<template>
  <div class="edit-page-wrapper">
    <EditUserForm />
  </div>
</template>

<script>
import EditUserForm from '@/components/editUser/EditUser'

export default {
  name: "EditUserPage",
  components: {
    EditUserForm
  }
}
</script>

<style scoped>
</style>